import { Stack } from "@mui/material";

const NotFound = () => {
  return <Stack>Not Found</Stack>;
};

export default NotFound;
